export default "__VITE_ASSET__By6K5s_f__"